export const SERIES_CHANGED = 'edimi:series-changed'

export function notifySeriesChanged() {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(SERIES_CHANGED))
}
